import { c as _c } from "react/compiler-runtime";
import { FaroBulkDialog } from "@components/common/faro-table/bulk-dialog/bulk-dialog";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { FaroTextMenuButton } from "@components/common/faro-text-menu-button";
import { getRoleMenuItemSx, RoleMenuItem } from "@components/role/role-menu-item";
import { ChangeRoleEntityType, useChangeRoleBulkDialogContent } from "@components/table/members/bulk-actions/bulk-change-role-helper";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { getTeamAssignedExclusions } from "@components/table/member-group-projects/bulk-actions/team-assignment-exclusion";
import { CHANGE_ROLE_THROUGH_TEAM_MESSAGE } from "@src/constants/team-constants";
import { FaroCoreApiConst } from "@stellar/core-api-client";
import { updateProjectRoleInMap } from "@store/company-member-groups/company-member-groups-slice";
import { updateMemberRoleInProjectBulk } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, selectedRowIdsSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { setBulkActionName, updateMany } from "@store/table/table-slice";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useEffect, useMemo, useRef, useState } from "react";
import { Text, UserRoleIcon, MenuItem } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { useCompanyId } from "@context-providers/company-id-provider";
/** Bulk action button that opens a role dropdown to change a member's role in selected projects */
export function BulkChangeGroupProjectRole(t0) {
  const $ = _c(53);
  const {
    member,
    projects,
    onRoleChanged
  } = t0;
  const companyId = useCompanyId();
  const dispatch = useAppDispatch();
  const mode = useBulkActionsMode();
  const [shouldShowDialog, setShouldShowDialog] = useState(false);
  const [newRole, setNewRole] = useState("RESOURCE_VIEWER");
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  let t1;
  if ($[0] !== projects || $[1] !== selectedRowIds) {
    let t2;
    if ($[3] !== selectedRowIds) {
      t2 = p => selectedRowIds.includes(p.id);
      $[3] = selectedRowIds;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = projects.filter(t2);
    $[0] = projects;
    $[1] = selectedRowIds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedProjects = t1;
  let t2;
  if ($[5] !== newRole) {
    t2 = {
      subjectType: "project",
      newRole,
      entityType: ChangeRoleEntityType.project
    };
    $[5] = newRole;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    bulkDialogContent,
    successDialogContent
  } = useChangeRoleBulkDialogContent(t2);
  let t3;
  let t4;
  if ($[7] !== shouldShowSuccessDialog) {
    t3 = () => {
      if (shouldShowSuccessDialog) {
        setShouldShowDialog(false);
      }
    };
    t4 = [shouldShowSuccessDialog];
    $[7] = shouldShowSuccessDialog;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  const hasRefetchedRef = useRef(false);
  let t5;
  let t6;
  if ($[10] !== bulkActionName || $[11] !== onRoleChanged || $[12] !== shouldShowSuccessDialog) {
    t5 = () => {
      const isThisAction = bulkActionName === "changeMemberProjectRole";
      if (!isThisAction || !shouldShowSuccessDialog) {
        hasRefetchedRef.current = false;
        return;
      }
      if (hasRefetchedRef.current) {
        return;
      }
      hasRefetchedRef.current = true;
      onRoleChanged();
    };
    t6 = [bulkActionName, shouldShowSuccessDialog, onRoleChanged];
    $[10] = bulkActionName;
    $[11] = onRoleChanged;
    $[12] = shouldShowSuccessDialog;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  useEffect(t5, t6);
  let t7;
  if ($[15] !== dispatch || $[16] !== selectedProjects) {
    t7 = function onNewRoleClicked(event) {
      dispatch(setBulkActionName("changeMemberProjectRole"));
      const exclusions = getTeamAssignedExclusions(selectedProjects, CHANGE_ROLE_THROUGH_TEAM_MESSAGE);
      if (exclusions.length) {
        dispatch(updateMany(exclusions));
      }
      setNewRole(event.currentTarget.dataset.myValue);
      setShouldShowDialog(true);
    };
    $[15] = dispatch;
    $[16] = selectedProjects;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const onNewRoleClicked = t7;
  let t8;
  if ($[18] !== companyId || $[19] !== dispatch || $[20] !== member.identity || $[21] !== newRole) {
    t8 = async function onChangeRoleConfirmed(project) {
      await dispatch(updateMemberRoleInProjectBulk({
        companyId,
        projectId: project.id,
        userIdentity: member.identity,
        payload: {
          role: newRole
        }
      })).unwrap();
      dispatch(updateProjectRoleInMap({
        projectId: project.id,
        newRole
      }));
    };
    $[18] = companyId;
    $[19] = dispatch;
    $[20] = member.identity;
    $[21] = newRole;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const onChangeRoleConfirmed = t8;
  let t9;
  if ($[23] !== mode) {
    t9 = getBulkActionButtonConfig(mode, "Change role");
    $[23] = mode;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const config = t9;
  let t10;
  if ($[25] !== config.shouldShowText) {
    t10 = config.shouldShowText ? <Text variant="buttonM">Change role</Text> : undefined;
    $[25] = config.shouldShowText;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = config.tooltipText;
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    };
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = config.rippleColor;
  let t14;
  if ($[28] !== config.sx) {
    t14 = () => config.sx;
    $[28] = config.sx;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <UserRoleIcon style={{
      width: 18,
      height: 18
    }} />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== onNewRoleClicked) {
    t16 = FaroCoreApiConst.allProjectRoles.map(role => role !== "RESOURCE_OWNER" && <MenuItem data-my-value={role} key={role} value={role} onClick={onNewRoleClicked} sx={getRoleMenuItemSx({
      isTableCell: false
    })}><RoleMenuItem role={role} /></MenuItem>);
    $[31] = onNewRoleClicked;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== config.rippleColor || $[34] !== config.tooltipText || $[35] !== t10 || $[36] !== t14 || $[37] !== t16) {
    t17 = <FaroTextMenuButton buttonTitle={t10} tooltipText={t11} menuPosition={t12} rippleColor={t13} shouldShowEndIcon={false} buttonSx={t14} startIcon={t15}>{t16}</FaroTextMenuButton>;
    $[33] = config.rippleColor;
    $[34] = config.tooltipText;
    $[35] = t10;
    $[36] = t14;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== bulkActionName || $[40] !== shouldShowSuccessDialog || $[41] !== successDialogContent) {
    t18 = bulkActionName === "changeMemberProjectRole" && shouldShowSuccessDialog && <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[39] = bulkActionName;
    $[40] = shouldShowSuccessDialog;
    $[41] = successDialogContent;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== bulkActionName || $[44] !== bulkDialogContent || $[45] !== onChangeRoleConfirmed || $[46] !== selectedProjects || $[47] !== shouldShowDialog) {
    t19 = bulkActionName === "changeMemberProjectRole" && shouldShowDialog && <FaroBulkDialog dialogContent={bulkDialogContent} onClose={() => setShouldShowDialog(false)} trackingEvent={BulkActionEvents.bulkChangeMemberProjectRole} bulkActionCallback={onChangeRoleConfirmed} selectedEntities={selectedProjects} uniqueIdKey="id" tableDataType="projects" />;
    $[43] = bulkActionName;
    $[44] = bulkDialogContent;
    $[45] = onChangeRoleConfirmed;
    $[46] = selectedProjects;
    $[47] = shouldShowDialog;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t17 || $[50] !== t18 || $[51] !== t19) {
    t20 = <>{t17}{t18}{t19}</>;
    $[49] = t17;
    $[50] = t18;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
}